//制造业重大项目方向

const indexAdmin = () => import('./indexAdmin');
const indexAppl = () => import('./indexAppl');
const edit = () => import('./edit.vue');
const enterAdmin = () => import('./enterAdmin');
const enterEdit = () => import('./enterEdit.vue');

export default {
  routes: [
    {
      path: '/smes/loan/2024V3/indexAppl',
      name: 'smes_loan_v2024_v3_index_appl',
      component: indexAppl,
      meta:{public:true}
    },
    {
      path: '/smes/loan/2024V3/indexAdmin',
      name: 'smes_loan_v2024_v3_index_admin',
      component: indexAdmin,
      meta: {public: true}
    },
    {
      path: '/smes/loan/2024V3/enterAdmin',
      name: 'smes_loan_v2024_v3_enter_admin',
      component: enterAdmin,
      meta: {public: true}
    },
    {
      path: '/smes/loan/2024V3/edit',
      name: 'smes_loan_2024_v3_edit',
      component: edit,
      meta: {public: true}
    },
    {
      path: '/smes/loan/2024V3/enterEdit',
      name: 'smes_loan_2024_v3_enter_edit',
      component: enterEdit,
      meta: {public: true}
    },
  ]
}



// WEBPACK FOOTER //
// ./src/components/smes/loan/v2024_3/router.js